module.exports = __webpack_public_path__ + "static/media/banner5.786c21f3.jpg";